export default "__VITE_ASSET__BsvCb7Xk__"